export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_09.8df2f015.png";